'use strict';
/**
 * @type {Object}
 * @property {Object} NOT_FOUND generic not found error code for whole user service
 * @property {Object} EXPIRED generic expired error code for whole user service
 */
var serviceErrorCodes = Object.freeze({
    NOT_FOUND                 : 'userService.notFound',
    ALREADY_EXISTS            : 'userService.alreadyExists',
    EXPIRED                   : 'userService.expired',
    NOT_ACTIVE                : 'userService.notActive',
    UNABLE_ACTIVATE           : 'userService.unableActivate',
    INVALID_CREDENTIALS       : 'userService.invalidCredentials',
    USER_BANNED               : 'userService.userBanned',
    PASSWORD_EXPIRED          : 'userService.passwordExpired',
    NO_PASSWORD               : 'userService.noPassword',    
    NOT_GHOST_ACCOUNT         : 'userService.notGhostAccount',
    TASK_EXPIRED              : 'userService.taskExpired',
    INVALID_TARGET_USER       : 'userService.invalidTargetUser',
    INVALID_SOURCE_USER       : 'userService.invalidSourceUser',
    ACHIEVEMENT_ALREADY_EXISTS: 'userService.achievementAlreadyExists',
    ACHIEVEMENT_NOT_FOUND     : 'userService.achievementNotFound',
    APP_NOT_FOUND             : 'userService.appNotFound',
    APP_NOT_EMPTY             : 'userService.appNotEmpty',
    APP_ALREADY_EXISTS        : 'userService.appAlreadyExists',
    CATEGORY_NOT_FOUND        : 'userService.categoryNotFound',
    EMAIL_NOT_SENT            : 'userService.emailNotSent',
    EMAIL_ALREADY_SENT        : 'userService.emailAlreadySent',
    SAVE_NOT_FOUND            : 'userService.saveNotFound',
    SAVE_ALREADY_EXISTS       : 'userService.saveAlreadyExists',
    MAX_BGSLT_COUNT_REACHED   : 'userService.maxBgsltCountReached',
    USER_LOCKED               : 'userService.userLocked',
    INVALID_GUEST_TOKEN       : 'userService.invalidGuestToken',
});

module.exports = serviceErrorCodes;